// extracted by css-extract-rspack-plugin
module.exports =  {"redDescription":"HasDependent__redDescription--IPZTU","primaryPanelHeader":"HasDependent__primaryPanelHeader--S1rtC"};